import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const useNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pendingSection, setPendingSection] = useState(null);
  const [isHomePage, setIsHomePage] = useState(location.pathname === '/');

  useEffect(() => {
    setIsHomePage(location.pathname === '/');
  }, [location]);

  useEffect(() => {
    if (isHomePage && pendingSection) {
      const timer = setTimeout(() => {
        scrollToSection(pendingSection);
        setPendingSection(null);
      }, 600);
      
      return () => clearTimeout(timer);
    }
  }, [isHomePage, pendingSection]);

  const scrollToSection = (sectionId) => {
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const headerHeight = 70;
        const elementPosition = element.offsetTop - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth'
        });
      }
    }, 150);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const navigateToHome = () => {
    navigate('/');
    scrollToTop();
  };

  const navigateToCriticas = () => {
    navigate('/criticas');
    scrollToTop();
  };

  const navigateToNovidades = () => {
    navigate('/novidades');
    scrollToTop();
  };

  const navigateToColetivas = () => {
    navigate('/coletivas');
    scrollToTop();
  };

  const navigateToSection = (sectionId) => {
    if (isHomePage) {
      scrollToSection(sectionId);
    } else {
      setPendingSection(sectionId);
      navigate('/');
    }
  };

  return {
    isHomePage,
    navigateToHome,
    navigateToCriticas,
    navigateToNovidades,
    navigateToColetivas,
    navigateToSection,
    scrollToTop,
    scrollToSection
  };
};
